import { render, staticRenderFns } from "./wang.vue?vue&type=template&id=5f59cb34&scoped=true"
import script from "./wang.vue?vue&type=script&lang=ts"
export * from "./wang.vue?vue&type=script&lang=ts"
import style0 from "./wang.vue?vue&type=style&index=0&id=5f59cb34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f59cb34",
  null
  
)

export default component.exports